// This file is needed to ensure client-side compatibility
export const prerender = false;
export const ssr = true;
